// Every language the landing page is published in; each gets its own indexable URL.
export const LANDING_LOCALES: { code: string; name: string; hreflang: string; dir?: 'rtl' }[] = [
  { code: 'en', name: 'English', hreflang: 'en' },
  { code: 'de', name: 'Deutsch', hreflang: 'de' },
  { code: 'fr', name: 'Français', hreflang: 'fr' },
  { code: 'es', name: 'Español', hreflang: 'es' },
  { code: 'es-ar', name: 'Español (Argentina)', hreflang: 'es-AR' },
  { code: 'pt-br', name: 'Português (Brasil)', hreflang: 'pt-BR' },
  { code: 'tr', name: 'Türkçe', hreflang: 'tr' },
  { code: 'ru', name: 'Русский', hreflang: 'ru' },
  { code: 'zh-cn', name: '简体中文', hreflang: 'zh-Hans' },
  { code: 'ja', name: '日本語', hreflang: 'ja' },
  { code: 'ko', name: '한국어', hreflang: 'ko' },
  { code: 'hi', name: 'हिन्दी', hreflang: 'hi' },
  { code: 'id', name: 'Bahasa Indonesia', hreflang: 'id' },
  { code: 'sv', name: 'Svenska', hreflang: 'sv' },
  { code: 'no', name: 'Norsk', hreflang: 'no' },
];

export const landingUrl = (code: string) => `https://mynawoo.com${code === 'en' ? '' : `/${code}`}`;

// Sections the landing page (and its header/footer) actually render.
export const LANDING_SECTIONS = ['landing', 'common', 'courses', 'header', 'footer', 'menu'];
